module.exports = __webpack_public_path__ + "img/avatar3.93618f2a.png";